import React, {useEffect, useRef} from 'react';
import styles from './style.css';
import {levelFromTimeDomain, pushLevel} from './level';
import {BARS, BAR_SECONDS, drawBars, setupCanvas} from './draw';

const SAMPLE_MS = BAR_SECONDS * 1000;

// Live voice waves while recording: a scrolling row of rounded bars whose
// heights follow the microphone level. Taps the recorder's own audio graph
// (the source node it already created), so no second microphone request.
// Colour is the theme accent (purple in base, gold in memorial).
export default function StickersComponentsLiveWaveform({audioContext, source}) {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas || !audioContext || !source) {
            return undefined;
        }
        const analyser = audioContext.createAnalyser();
        analyser.fftSize = 1024;
        analyser.smoothingTimeConstant = 0.6;
        source.connect(analyser);
        const samples = new Uint8Array(analyser.fftSize);

        const surface = setupCanvas(canvas);
        let history = new Array(BARS).fill(0);
        let frame = 0;
        let lastSample = 0;

        const draw = (now) => {
            if (now - lastSample >= SAMPLE_MS) {
                analyser.getByteTimeDomainData(samples);
                history = pushLevel(history, levelFromTimeDomain(samples));
                lastSample = now;
            }
            drawBars(surface, history);
            frame = requestAnimationFrame(draw);
        };
        frame = requestAnimationFrame(draw);

        return () => {
            cancelAnimationFrame(frame);
            try { source.disconnect(analyser); } catch (e) { /* already gone */ }
        };
    }, [audioContext, source]);

    return <canvas ref={canvasRef} className={styles.waveform} aria-hidden="true"/>;
}
